<template>
  <v-container fluid style="margin: 1px; width: 100%; height: 100%">
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-row justify="center">
      <v-avatar size="250">
        <img :src="photo ? photo : require('@/assets/blank-photo.png')" />
        <!-- <v-img :src="photo" /> -->
      </v-avatar>
    </v-row>
    <v-row justify="space-around">
      <h1 style="size: 3rem; weight: 400">{{ name }}</h1>
    </v-row>
    <br />
    <v-row v-if="mayor === undefined" justify="center">
      <v-icon>mdi-plus</v-icon>
    </v-row>
    <v-row v-else justify="center">
      <v-btn
        width="175px"
        class="margin-right: 300px;"
        @click="dialog = true"
        color="blue"
        ><v-icon> mdi-pencil </v-icon>
        {{ $t("common.edit").toLocaleUpperCase(lang) }}
      </v-btn>
      <input
        ref="uploader"
        class="d-none"
        type="file"
        multiple
        @change="onFileChanged()"
      />
      <v-btn
        width="175px"
        v-if="photo === ''"
        @click="addMayorPhotoTrigger"
        color="green"
        ><v-icon> mdi-camera </v-icon>
        {{ $t("actions.uploadPhoto").toLocaleUpperCase(lang) }}
      </v-btn>
      <v-btn width="175px" v-else @click="deleteConfirm = true" color="red"
        ><v-icon> no_photography </v-icon>
        {{ $t("actions.deletePhoto").toLocaleUpperCase(lang) }}
      </v-btn>
    </v-row>
    <br />
    <br />
    <br />
    <v-row>
      <v-card>
        <v-card-title>
          {{ $t("_mayor.cv") }}
        </v-card-title>
        <v-card-text>
          {{ cv }}
        </v-card-text>
      </v-card>
    </v-row>

    <template>
      <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="text-h5">
                {{ $t("common.edit").toLocaleString(lang) }}
              </span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-text-field
                  :label="$t('_mayor.name')"
                  v-model="mayorForm.name"
                ></v-text-field>
                <v-textarea
                  :label="$t('_mayor.cv')"
                  counter="2500"
                  v-model="mayorForm.cv"
                >
                </v-textarea>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialog = false">
                {{ $t("common.cancel").toLocaleUpperCase(lang) }}
              </v-btn>
              <v-btn color="blue darken-1" text @click="updateMayorTrigger">
                {{ $t("common.save").toLocaleUpperCase(lang) }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>

      <v-dialog v-model="deleteConfirm" min-width="600px" max-width="600px">
        <v-card>
          <v-card-title>
            <span class="text-h5">
              {{ $t("_mayor.deletePhoto").toLocaleString(lang) }}
            </span>
          </v-card-title>
          <v-card-text>
            {{ $t("_mayor.warning").toLocaleString(lang) }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" text @click="deleteMayorPhotoTrigger">
              {{ $t("common.delete").toLocaleUpperCase(lang) }}
            </v-btn>
            <v-btn color="green" text @click="deleteConfirm = false">
              {{ $t("common.no").toLocaleUpperCase(lang) }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template></v-container
  >
</template>


<script>
import { mapActions, mapGetters } from "vuex";
export default {
  // components: { IssueTable },
  data() {
    return {
      dialog: false,
      deleteConfirm: false,
      mayorForm: {
        name: "",
        cv: "",
      },
      name: "",
      cv: "",
      photo: "",
      overlay: true,
    };
  },
  async created() {
    console.log("Mayor Page is refreshing due to creating");
    await this.refreshPage();
    console.log(this.mayor);
  },
  computed: {
    ...mapGetters({ mayor: "mayor/items" }),
    ...mapGetters({ language: "app/language" }),
    lang() {
      return this.language.replaceAll("_", "-");
    },
  },
  methods: {
    ...mapActions({ getMayor: "mayor/getMayor" }),
    ...mapActions({ updateMayor: "mayor/updateMayor" }),
    ...mapActions({ delete: "mayor/uploadMayorPhoto" }),
    ...mapActions({ addMayorPhoto: "mayor/uploadMayorPhoto" }),
    ...mapActions({ deleteMayorPhoto: "mayor/deleteMayorPhoto" }),
    async refreshPage() {
      await this.getMayor();
      this.overlay = false;
    },
    async updateMayorTrigger() {
      console.log(this.mayorForm);
      await this.updateMayor(this.mayorForm);
      await this.refreshPage();
      this.dialog = false;
    },
    async addMayorPhotoTrigger() {
      console.log(this.$refs.uploader);
      this.$refs.uploader.click();
    },
    async deleteMayorPhotoTrigger() {
      console.log("delete is called");
      await this.deleteMayorPhoto();
      this.photo = "";
      this.deleteConfirm = false;
    },
    async onFileChanged() {
      let files = this.$refs.uploader.files;
      //let files = e.target.files;
      console.log(files);
      for (let file of files) {
        console.log(file);
        console.log(file.type.split("/")[0]);
        if (
          file.type.split("/")[0] === "image" &&
          file.name.length > 2
          //&& file.size < 150000
        ) {
          console.log(file);
          try {
            await this.addMayorPhoto({
              file: file,
            });
            // this.snackbar = true;
            // this.snackColor = "success";
            // this.snackText = "Fotoğraf yüklendi!";
            // this.y = "bottom";
            // this.x = "right";
            // this.mode = "multi-line";
          } catch (e) {
            // this.snackbar = true;
            // this.snackColor = "error";
            // this.snackText = "Fotoğraf yüklenemedi!";
            // this.y = "bottom";
            // this.x = "right";
            // this.mode = "multi-line";
            console.error(e);
          }
        } else {
          console.log("invalid file.");
          // this.snackbar = true;
          // this.snackColor = "error";
          // this.snackText = "Dosya formatı geçersiz!";
          // this.y = "bottom";
          // this.x = "right";
          // this.mode = "multi-line";
        }

        //let file = files[i];
      }
      this.$refs.uploader.value = "";
      await this.refreshPage();
    },
  },
  watch: {
    mayor(newVal, oldVal) {
      console.log("new", newVal);
      console.log("old", oldVal);
      this.name = this.mayorForm.name = newVal.name;
      this.cv = this.mayorForm.cv = newVal.cvContent.originalText;
      this.photo = this.photo !== undefined ? newVal.mayorPhoto.assetUrl : "";
    },
  },
};
</script>


<style>
</style>
